import React from 'react';
import { Box, Typography } from '@mui/material';
import { Inbox } from 'lucide-react';

const EmptyState = ({ 
  icon: Icon = Inbox, 
  title = "No data found", 
  description = "There is nothing to display right now.",
  containerHeight = "200px"
}) => {
  return (
    <Box 
      sx={{ 
        display: 'flex', 
        flexDirection: 'column', 
        alignItems: 'center', 
        justifyContent: 'center', 
        height: containerHeight,
        textAlign: 'center',
        padding: '24px',
        opacity: 0.8
      }}
    >
      <Box 
        sx={{ 
          color: '#94a3b8', 
          marginBottom: '16px',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          background: '#f1f5f9',
          padding: '16px',
          borderRadius: '50%'
        }}
      >
        <Icon size={32} />
      </Box>
      <Typography 
        variant="subtitle1" 
        sx={{ 
          fontWeight: 700, 
          color: '#475569', 
          marginBottom: '4px' 
        }}
      >
        {title}
      </Typography>
      <Typography 
        variant="body2" 
        sx={{ 
          color: '#94a3b8', 
          maxWidth: '240px' 
        }}
      >
        {description}
      </Typography>
    </Box>
  );
};

export default EmptyState;
